/* ============ Homepage topic pills ============ */
(function () {
  var tabs = $('#topic-tabs');
  var grid = $('#stories-grid');
  if (!tabs || !grid) return;

  /* Reorder the pills to match the order of slugs in the homepage_topics setting.
     Ghost's {{#get "tags"}} can't guarantee that order itself. */
  var order = (tabs.dataset.order || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  if (order.length) {
    var all = $('[data-topic="all"]', tabs);
    var bySlug = {};
    $$('.tab', tabs).forEach(function (t) { bySlug[t.dataset.topic] = t; });
    order.forEach(function (slug) {
      if (bySlug[slug]) tabs.appendChild(bySlug[slug]);
    });
    if (all) tabs.insertBefore(all, tabs.firstChild);
  }

  var active = 'all';

  window.rootedApplyTopicFilter = function (scope) {
    $$('.card', scope || grid).forEach(function (card) {
      var show = active === 'all' || card.dataset.topic === active;
      card.classList.toggle('is-hidden', !show);
    });
  };

  tabs.addEventListener('click', function (e) {
    var t = e.target.closest('.tab');
    if (!t) return;
    active = t.dataset.topic;
    $$('.tab', tabs).forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
    window.rootedApplyTopicFilter();
  });
})();
